<template>
  <div class="distributingDevOpsPage mainPageBg">
    <DevOpsPublicCom :system="'配电系统'" />
  </div>
</template>

<script>
import DevOpsPublicCom from "@/components/DevOps/DevOpsPublicCom.vue";
export default {
  components: {
    DevOpsPublicCom,
  },
};
</script>

<style></style>
